import { buildSavedViewFiltersJson, parseSavedViewFilters } from '../../shared/saved-views/saved-view-filters';

/** Multi-select filter shape of the module overview, serialized into `SavedView.filtersJson` (NEX-788). */
export interface ModuleSavedViewFilters {
  query: string | null;
  status: string[];
  author: string[];
  /** Fehlt bei leerer Auswahl und in älteren Ansichten; beides heißt „Alle Tags“. */
  tags?: string[];
}

const EMPTY_MODULE_SAVED_VIEW_FILTERS: ModuleSavedViewFilters = {
  query: null,
  status: [],
  author: [],
};

export function parseModuleSavedViewFilters(filtersJson: string | null): ModuleSavedViewFilters {
  const filters = parseSavedViewFilters(filtersJson, EMPTY_MODULE_SAVED_VIEW_FILTERS);
  const tags = parseTags(filtersJson);
  return tags.length > 0 ? { ...filters, tags } : filters;
}

function parseTags(filtersJson: string | null): string[] {
  const { tags } = parseSavedViewFilters<{ tags: unknown }>(filtersJson, { tags: [] });
  return Array.isArray(tags) ? tags.filter((tag): tag is string => typeof tag === 'string') : [];
}

export function buildModuleSavedViewFiltersJson({ tags, ...filters }: ModuleSavedViewFilters): string {
  return buildSavedViewFiltersJson(tags?.length ? { ...filters, tags } : filters);
}
